import { render } from "./VenueSelectApostille.vue?vue&type=template&id=d83ae48a"
import script from "./VenueSelectApostille.vue?vue&type=script&lang=js"
export * from "./VenueSelectApostille.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/checkout/VenueSelectApostille.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d83ae48a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d83ae48a', __exports__)) {
    api.reload('d83ae48a', __exports__)
  }
  
  module.hot.accept("./VenueSelectApostille.vue?vue&type=template&id=d83ae48a", () => {
    api.rerender('d83ae48a', render)
  })

}


export default __exports__